export default __webpack_public_path__ + "static/media/logo.c57c8948.svg";